import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';




const Kosten = () => {
    return (
        <>
        <Helmet>
                    <title>Kostenübernahme</title>
                    <meta name="description" content='Ich orientiere mich an den Honorarempfehlungen des VDOe. Die Kostenübernahme ist von Kasse zu Kasse unterschiedlich, manche Kassen übernehmen die gesamten Kosten, andere übernehmen den größten Teil der Kosten.' />
                </Helmet>
        <div className='Bildung'>
            <div className="BeratungWrapper">
                <div className='entrycontent'>

                    <h2 className='header'>Kosten und Kostenübernahme durch ihre Krankenkasse</h2>

                    <p className='text'>Zur Kostenübernahme durch die Krankenkasse sind eine <Link to={"/AerztlicheBescheinigung"} className="showLink">ärztliche Bescheinigung</Link> bzw. ein Rezept erforderlich sowie ein von mir erstellter Kostenvoranschlag.
                        Ich orientiere mich an den Honorarempfehlungen des VDOe, die Kosten sind je nach Krankheitsbild unterschiedlich.
                        Den Kostenvoranschlag erstelle ich Ihnen kostenlos nach Zusendung der ärztlichen Zuweisung.
                        Die Kostenübernahme ist von Kasse zu Kasse unterschiedlich, manche Kassen übernehmen die gesamten Kosten, andere übernehmen den größten Teil der Kosten.
                    </p>

                    <br></br>
                    <br></br>
                    <h2 className='header'>Wegweiser Kostenvoranschlag</h2>

                    <p className='text'>Zur Erstellung des Kostenvoranschlags benötige ich eine <Link to={"/AerztlicheBescheinigung"} className="showLink">ärztliche Zuweisung</Link> oder ein Rezept von Ihnen.
                        Die Zuweisung senden Sie bitte an meine Mail-Adresse oder sie schicken diese per Post.
                        Auf der ärztlichen Zuweisung sollten die Diagnose, „Ernährungstherapie nach § 43“ oder „Ernährungsberatung nach § 20“ sowie Ihre Adresse, Geburtsdatum und Krankenkasse vermerkt sein.
                        Sie können auch gerne das von den Krankenkassen anerkannte Formular auf meiner Website ausdrucken, Ihre Daten eintragen und von Ihrem Arzt oder Ihrer Ärztin vervollständigen lassen.
                        Ich erstelle den Kostenvoranschlag und leite Ihn an Ihre Krankenkasse und an Sie weiter.
                        Sobald Sie dann Antwort von Ihrer Krankenkasse erhalten haben, melden Sie sich bitte in meiner Praxis und wir vereinbaren kurzfristig einen Termin.
                    </p>

                </div >

            </div>

        </div>
    </>);
}

export default Kosten;
